export type Photo = { src: string; alt: string };

export const photos = {
  homeHero: {
    src: "https://cdn.magicpatterns.com/patterns/generated-images/671e79eb-bef7-41b3-a8d8-20353aa732d9.jpg",
    alt: "A quiet private office in early light — a walnut desk with a navy notebook, squared documents, and a fountain pen beside tall windows.",
  },
  conferenceRoom: {
    src: "https://cdn.magicpatterns.com/patterns/generated-images/9b981d8a-e984-45a5-889a-3335cc4b8275.jpg",
    alt: "An empty conference room in late-afternoon light, chairs evenly set and documents prepared before a working session.",
  },
  rescueDesk: {
    src: "https://cdn.magicpatterns.com/patterns/generated-images/2ee53cac-50b5-4410-a937-68f696d6f454.jpg",
    alt: "An experienced operator working calmly at a walnut desk in morning sun, marking a payroll calendar beside a laptop and neat reports.",
  },
  operatorCandid: {
    src: "https://cdn.magicpatterns.com/patterns/generated-images/73bd9f31-939d-4308-888c-196546636f48.jpg",
    alt: "A quiet office in early-morning sun, one person working at a walnut desk with a report and calendar while a colleague passes with a folder.",
  },
  payrollMaterials: {
    src: "https://cdn.magicpatterns.com/patterns/generated-images/5dba5844-50ad-4699-84c1-a1f49ff5f450.jpg",
    alt: "Overhead view of an ordered desk — a paper calendar with marked dates, a navy ledger, tabbed folders, and a pencil laid parallel.",
  },
  hrtechArchitecture: {
    src: "https://cdn.magicpatterns.com/patterns/generated-images/f44c506d-b69f-4718-81f0-11a151ebc380.jpg",
    alt: "A glass-walled meeting room framed by a precise steel grid, with a closed laptop and documents on a walnut table.",
  },
  hrtechHands: {
    src: "https://cdn.magicpatterns.com/patterns/generated-images/8c381411-a869-40ae-a96c-ecd85e991383.jpg",
    alt: "Hands annotating a printed system configuration document in pencil beside an open laptop.",
  },
  optimizeFiles: {
    src: "https://cdn.magicpatterns.com/patterns/generated-images/fa691742-81e0-4889-b2d7-9826c84fd294.jpg",
    alt: "Walnut shelving lined with evenly spaced archival boxes and navy binders in raking afternoon light.",
  },
  ledgerBook: {
    src: "https://cdn.magicpatterns.com/patterns/generated-images/155f8589-e71c-4ce7-8e3c-2017e3676fd0.jpg",
    alt: "An open bound ledger on ivory linen with an oxblood ribbon marker and a navy fountain pen.",
  },
  aboutFocus: {
    src: "https://cdn.magicpatterns.com/patterns/generated-images/93e1af17-0c75-4ce7-8767-e8e0f0b8679a.jpg",
    alt: "A person seen from behind, reviewing documents at a desk by a tall window in morning light.",
  },
  implementationRoom: {
    src: "https://cdn.magicpatterns.com/patterns/generated-images/afad4312-7ca5-4344-ba7d-9aed91af8163.jpg",
    alt: "A bright project room in late-morning light, test scripts squared into neat stacks while an operator calmly reviews a document.",
  },
  taxCorrespondence: {
    src: "https://cdn.magicpatterns.com/patterns/generated-images/7749b689-140d-4f30-a1ea-a0e306b11f4c.jpg",
    alt: "Agency correspondence sorted into aligned piles on a walnut desk, one letter opened and clipped beside a navy folder.",
  },
  servicesHero: {
    src: "https://cdn.magicpatterns.com/patterns/generated-images/cb1fa5f3-881a-428e-9dd2-ac22aaa0e790.jpg",
    alt: "A daylight workspace in motion — one operator marking a printed project plan while a colleague reviews a document and another files a folder.",
  },
  payroll911: {
    src: "https://cdn.magicpatterns.com/patterns/generated-images/a8960df2-c522-4f82-a4fc-d1ee9489ea0b.jpg",
    alt: "An operator working steadily at a walnut desk in morning light — a spreadsheet on the laptop, a ticked report, and a calendar with one date circled.",
  },
  configurationReview: {
    src: "https://cdn.magicpatterns.com/patterns/generated-images/1cc45085-c9b7-4594-97b3-081e22b4f689.jpg",
    alt: "An operator comparing a payroll system's configuration settings and rules on a large monitor against a printed reference and notebook, in warm daylight.",
  },
  implementationsPlanned: {
    src: "https://cdn.magicpatterns.com/patterns/generated-images/c39c8562-5bf5-435b-8814-3666bfc0a747.jpg",
    alt: "An implementation being built methodically — a configuration checklist and integration mapping on screen, beside ordered binders and ticked test scripts.",
  },
  taxRemediation: {
    src: "https://cdn.magicpatterns.com/patterns/generated-images/c22d0325-b31e-4a67-83b3-c5421cede338.jpg",
    alt: "Agency notices sorted into navy folders beside a laptop and a handwritten resolution list, one letter moving into a completed folder.",
  },
  corridor: {
    src: "https://cdn.magicpatterns.com/patterns/generated-images/2e2d3ac0-6c0b-4a15-87e1-208fa9bb70f8.jpg",
    alt: "A quiet office corridor in early morning, low sun casting an even rhythm of light along repeating glass doors.",
  },
};
